import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./context/ThemeContext";
import CursorTrail from "./components/CursorTrail";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProgramsPage from "./pages/ProgramsPage";
import JummahPage from "./pages/JummahPage";
import DonatePage from "./pages/DonatePage";
import VolunteerPage from "./pages/VolunteerPage";
import SupportPage from "./pages/SupportPage";
import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import GovernancePage from "./pages/GovernancePage";
import ContactPage from "./pages/ContactPage";
import GalleryPage from "./pages/GalleryPage";
import EventsPage from "./pages/EventsPage";
import RamadanPage from "./pages/RamadanPage";
import AdminGalleryPage from "./pages/AdminGalleryPage";
import EducationPage from "./pages/EducationPage";
import AdultEducationPage from "./pages/AdultEducationPage";
import PlaceToWorshipPage from "./pages/PlaceToWorshipPage";
import FundraisingPage from "./pages/FundraisingPage";
import BoardPage from "./pages/BoardPage";
import FlyersPage from "./pages/FlyersPage";
import AdminPanel from "./pages/AdminPanel";

// Layout wrapper
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <CursorTrail />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/jummah" element={<JummahPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/donate/success" element={<DonatePage />} />
            <Route path="/volunteer" element={<VolunteerPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:slug" element={<NewsDetailPage />} />
            <Route path="/governance" element={<GovernancePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/ramadan" element={<RamadanPage />} />
            <Route path="/education" element={<EducationPage />} />
            <Route path="/adult-education" element={<AdultEducationPage />} />
            <Route path="/place-to-worship" element={<PlaceToWorshipPage />} />
            <Route path="/fundraising" element={<FundraisingPage />} />
            <Route path="/board" element={<BoardPage />} />
            <Route path="/flyers" element={<FlyersPage />} />
            <Route path="/truenorthmuslim" element={<AdminPanel />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/truenorthmuslim/gallery" element={<AdminGalleryPage />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
